import api, { request } from '../../../api';
import { groupBy } from '../../../contrib/utils';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IAdminEventResultsStore } from './store';

export interface IAdminEventResultsActions {
  get: (
    eventId: number,
    force?: boolean
  ) => { adminEventResults?: IAdminEventResultsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (state: IStore, eventId: number, force?: boolean) => {
    if (state.adminEventResults[eventId] && !force) {
      return {
        adminEventResults: state.adminEventResults
      };
    }
    const response = await request.get(api.admin.eventResults({ event_id: eventId }));

    if (response.error) {
      return {
        errors: { adminEventResults: { msg: 'Error retrieving the Event Format Awards List.' } }
      };
    }

    return {
      adminEventResults: {
        ...state.adminEventResults,
        [eventId]: {
          ...state.adminEventResults[eventId],
          ...groupBy(response, 'flightId')
        }
      }
    };
  }
};

export default actions;
